"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./style.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var sizes = {
  xs: 8,
  sm: 16,
  md: 24,
  lg: 32
};

function AccountsinactiveMultitoneOutline(_ref) {
  var className = _ref.className,
      inheritFontColor = _ref.inheritFontColor,
      inheritFontSize = _ref.inheritFontSize,
      size = _ref.size,
      width = _ref.width,
      height = _ref.height,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      muted = _ref.muted,
      clickable = _ref.clickable,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["className", "inheritFontColor", "inheritFontSize", "size", "width", "height", "disabled", "onClick", "muted", "clickable", "children"]);

  var classes = ['orion-icons-svg-base'];

  if (inheritFontColor) {
    classes.push('orion-icons-svg-current-clr');
  }

  if (muted) {
    classes.push('orion-icons-svg-muted');
  }

  if (!disabled && (clickable || typeof onClick === 'function')) {
    classes.push('orion-icons-svg-clickable');
  }

  if (disabled) {
    classes.push('orion-icons-svg-disabled');
  }

  classes.push(className);
  var finalWidth = width || sizes[size];
  var finalHeight = height || sizes[size];

  if (inheritFontSize) {
    finalWidth = finalHeight = '1em';
  }

  var finalClass = classes.filter(Boolean).join(' ');
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: finalWidth,
    height: finalHeight,
    fill: "none",
    viewBox: "0 0 16 16",
    color: "currentColor",
    className: finalClass,
    onClick: !disabled ? onClick : null
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__accountsinactive-multitone-outline__clip0_14553_7361)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.667,
    cy: 6.84,
    fill: "#CCE5FF",
    rx: 4,
    ry: 4.104
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M1.22 4.096l3.8 1.326v6.707l-3.8-1.401V4.096zM0 2.348v9.264l.093.034 5.956 2.19.19.07V4.53l-.097-.034-5.95-2.085L0 2.348zM13.098 2.415L7.146 4.501l-.097.033v9.376l.19-.07.737-.272c.16-.062.299-.172.399-.315a.908.908 0 00.162-.49v-.162a.534.534 0 00-.216-.505h-.049V5.422l3.801-1.33v3.712c0 .166.064.325.179.442a.602.602 0 00.862 0 .634.634 0 00.179-.442V2.348l-.195.067zM6.76 1.293l2.183.726-2.162.755-2.354-.805 2.333-.676zM6.76 0L.715 1.74v.283l6.02 2.052h.094l5.586-1.944v-.28L6.825 0H6.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M12.561 16a3.394 3.394 0 01-2.18-.803 3.555 3.555 0 01-1.194-2.037 3.623 3.623 0 01.039-1.546c.124-.506.355-.977.678-1.38a3.457 3.457 0 011.187-.951 3.37 3.37 0 011.47-.34c.912 0 1.787.371 2.432 1.033A3.576 3.576 0 0116 12.471c0 .936-.362 1.834-1.007 2.495A3.395 3.395 0 0112.56 16zm0-5.806a2.18 2.18 0 00-1.223.389c-.361.25-.643.603-.81 1.017-.18.418-.229.882-.142 1.33a2.202 2.202 0 001.726 1.774c.43.088.876.043 1.282-.13.405-.172.752-.463.996-.838a2.32 2.32 0 00-.276-2.875 2.191 2.191 0 00-1.57-.667h.017z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6C757D",
    d: "M13.35 13.097h-1.561a.602.602 0 01-.432-.183.634.634 0 010-.885.602.602 0 01.432-.183h1.58c.163 0 .318.066.432.183a.634.634 0 010 .885.602.602 0 01-.431.183h-.02z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__accountsinactive-multitone-outline__clip0_14553_7361"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0H16V16H0z"
  }))));
}

AccountsinactiveMultitoneOutline.propTypes = {
  size: _propTypes["default"].string,
  width: _propTypes["default"].number,
  height: _propTypes["default"].number,
  className: _propTypes["default"].string,
  inheritFontColor: _propTypes["default"].bool,
  inheritFontSize: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  clickable: _propTypes["default"].bool,
  muted: _propTypes["default"].bool
};
AccountsinactiveMultitoneOutline.defaultProps = {
  size: 'sm',
  className: '',
  inheritFontColor: false,
  inheritFontSize: false,
  disabled: false,
  onClick: null,
  clickable: false,
  muted: true
};
var _default = AccountsinactiveMultitoneOutline;
exports["default"] = _default;